import React from 'react';
import PropTypes from 'prop-types';
import { Form, Radio } from 'antd';

import './radio.scss';

const { Item } = Form;

const IndividualRadio = ({
  data = [],
  radioBoxName,
  isShowUpText = true,
  upTextStyles = {},
  isShowDownText = false,
  downTextStyles = {},
  isShowTitle = true,
  titleStyles = {},
  name = '',
  style = {},
  itemKey,
  label,
  disabled,
  click = () => {},
}) => (
  <Item
    name={name}
    style={style}
    key={itemKey}
    label={label}
    className={`individual-radio-box ${radioBoxName}`}
  >
    <Radio.Group
      disabled={disabled}
      onChange={(e) => {
        click(e.target.value, name);
      }}
    >
      {Array.isArray(data) &&
        data.map((item, idx) => (
          <Radio
            value={idx}
            key={idx}
            className={isShowDownText === true && 'isShowDownText'}
          >
            <span>
              {isShowTitle === true ? (
                <span
                  style={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    fontSize: '0.875rem',
                    ...titleStyles,
                  }}
                >
                  {item.title}
                </span>
              ) : null}

              {isShowUpText === true ? (
                <span
                  className="upText"
                  style={{
                    position: 'absolute',
                    left: '0',
                    bottom: isShowDownText === true ? '68%' : '50%',
                    width: '100%',
                    fontSize: '0.875rem',
                    whiteSpace: 'pre-wrap',
                    ...upTextStyles,
                  }}
                >
                  {item.text}
                </span>
              ) : null}

              {isShowDownText === true ? (
                <span
                  style={{
                    position: 'absolute',
                    left: '0',
                    bottom: '15%',
                    width: '100%',
                    textAlign: 'center',
                    fontSize: '0.875rem',
                    whiteSpace: 'pre-wrap',
                    ...downTextStyles,
                  }}
                >
                  {idx + 1}
                </span>
              ) : null}
            </span>
          </Radio>
        ))}
    </Radio.Group>
  </Item>
);
IndividualRadio.propTypes = {
  data: PropTypes.array.isRequired,
  radioBoxName: PropTypes.string,
  isShowUpText: PropTypes.bool,
  isShowDownText: PropTypes.bool,
  name: PropTypes.string,
  titleStyles: PropTypes.object,
  upTextStyles: PropTypes.object,
  downTextStyles: PropTypes.object,
  style: PropTypes.object,
  itemKey: PropTypes.any,
  label: PropTypes.string,
  click: PropTypes.func,
};
export default IndividualRadio;
